<!-- Modal -->
<template>
    <div class="modal fade" id="editPermissionGroups" ref="editPermissionGroups" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row w-100">
                        <h5 class="modal-title col-11" id="editPermissionGroupsLabel">Permission groups</h5>
                        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
                        <small class="col-12">Here you can rename or delete permission groups.</small>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="form-group mb-3">
                        <input type="text" @change="getPermissionGroups" v-model="search" class="form-control" placeholder="🔍 Search groups..." />
                    </div>

                    <div class="border rounded p-4 mb-5">
                        <div v-if="groups.length && !inProgress">
                            <table class="juniper-table">
                                <thead>
                                    <tr>
                                        <td width="50" class="text-center">#</td>
                                        <td class="text-start">Group name</td>
                                        <td width="200">Actions</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="cursor-pointer" v-for="group in groups" :key="group.id + '-group-key'">
                                        <td class="text-center">{{ group.id }}</td>
                                        <td class="text-start">
                                            
                                            <span v-if="!openForEditGroups[group.id]">
                                                {{ group.name }}
                                            </span>
                                            <span v-if="openForEditGroups[group.id]">
                                                <input class="form-control" type="text" v-model="openForEditGroups[group.id].name">
                                            </span>
                                        </td>
                                        <td>
                                            <button
                                                class="btn btn-primary btn-sm me-1"
                                                data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="top"
                                                v-if="!openForEditGroups[group.id] && userHasAllNeededJuniperPermissions(['update_permission_groups'])"
                                                @click="enableGroupForEdit(group)"
                                                role="button"
                                                title="Open for edit"
                                            >
                                                <font-awesome-icon v-if="!savingGroupIds.includes(group.id)" :icon="['fas', 'edit']" class="" />
                                                <font-awesome-icon v-if="savingGroupIds.includes(group.id)" :icon="['fas', 'cog']" spin />
                                            </button>
                                            <button
                                                class="btn btn-primary btn-sm me-1"
                                                data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="top"
                                                v-if="openForEditGroups[group.id] && userHasAllNeededJuniperPermissions(['update_permission_groups'])"
                                                @click="saveGroup(group)"
                                                role="button"
                                                title="Save group"
                                            >
                                                <font-awesome-icon :icon="['far', 'save']" class="" />
                                            </button>
                                            <button
                                                class="btn btn-danger btn-sm"
                                                data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="top"
                                                v-if="userHasAllNeededJuniperPermissions(['delete_permission_groups'])"
                                                @click="deleteGroup(group)"
                                                title="Delete group"
                                            >
                                                <font-awesome-icon :icon="['fas', 'trash']" class="" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="!inProgress && !groups.length">
                            No groups data.
                        </div>
                        <div v-if="inProgress" class="text-center">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { Modal } from "bootstrap";
import juniperApi from '@/api/juniperApi'
import juniperUserMixin from "@/mixins/juniperUserMixin";

export default {
    name: "EditPermissionGroupsModal",
    components: {
    },
    emits: ["editPermissionGroupModalClosed"],
    data: () => ({
        modal: null,
        groups: [],
        openForEditGroups: {},
        search: '',
        savingGroupIds: [],
        atLeastOneChangeMade: false,
        inProgress: false
    }),
    mounted() {
        this.modal = new Modal(this.$refs.editPermissionGroups);

        let editPermissionGroups = document.getElementById("editPermissionGroups");

        let self = this;
        
        editPermissionGroups.addEventListener("hidden.bs.modal", function () {
            
            self.$emit("editPermissionGroupModalClosed", self.atLeastOneChangeMade);
            
            self.groups = [];
            self.openForEditGroups = {};
            self.search = '';
            self.savingGroupIds = [];
            self.inProgress = false;
        });
    },
    watch: {
    },
    methods: {
        showModal: async function (value) {
            if (value) {
                this.modal.show();
                this.atLeastOneChangeMade = false;
                this.getPermissionGroups();
            }
        },
        async getPermissionGroups() {
			this.inProgress = true;
			juniperApi
				.get(`/permission-groups?search=${this.search}`)
				.then(({ data }) => {
                    
					this.groups = data;
                    this.inProgress = false;
				})
				.catch(error => {
					this.inProgress = false;
					console.log(error)
				})
		},
        enableGroupForEdit(group) {
            this.openForEditGroups = {...this.openForEditGroups, ...{[group.id]: group}};
        },
        async saveGroup(group) {
            this.savingGroupIds.push(group.id);
            
			try {
                await juniperApi.put(`/permission-groups/${group.id}`, group);
                
                this.openForEditGroups = Object.keys(this.openForEditGroups).filter((groupId) => this.openForEditGroups[groupId].id !== group.id);
                this.savingGroupIds = this.savingGroupIds.filter(groupId => groupId !== group.id);

                this.$swal.fire({
                    icon: 'success',
                    title: 'Permission group renamed successfully!',
                    timer: 4000,
                });
                this.atLeastOneChangeMade = true;

            } catch (error) {
                // this.savingGroupIds = this.savingGroupIds.filter(groupId => groupId !== group.id);
                let message = ''
                if (error.response.data.error) {
                    for (const [key, value] of Object.entries(error.response.data.error)) {
                        console.log(key)
                        message += ` ${value} \n`
                    }
                }
                this.$swal.fire({
                    icon: 'error',
                    title: message,
                    timer: 4000,
                });
            }
        },
        deleteGroup(group) {
            this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                html: `Are you sure you want to delete permission group <b>${group.name}</b>? ${group.permissions.length} permission/s are in this group and will be transfered to General group.`,
                confirmButtonText: "Yes, delete the permission group!",
                showLoaderOnConfirm: true,
				toast: false,
				position: 'center',
				showConfirmButton: true,
				timer: undefined,
				timerProgressBar: false,
				confirmButtonColor: "#0FCB4F",
				cancelButtonColor: "#EC2641",
                preConfirm: async () => {
                    try {
                        let res = await juniperApi.delete(`/permission-groups/${group.id}`, {});
                        this.atLeastOneChangeMade = true;
                        return res;
                    } catch (error) {
                        this.$swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
            }).then(async (result) => {
                if (result.isConfirmed) {
					if (result.value && result.value.data == 'success') {
                        
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Permission group deleted successfully!',
                            toast: false,
                            position: 'center',
                            showConfirmButton: true,
                            timer: undefined,
                            timerProgressBar: false,
                            confirmButtonColor: "#0FCB4F",
                            cancelButtonColor: "#EC2641",
                        });
						this.getPermissionGroups();
					} else {
                        this.$swal.fire({
                            icon: 'error',
                            title: "There was a problem, permission group wasn't deleted.",
                            toast: false,
                            position: 'center',
                            showConfirmButton: true,
                            timer: undefined,
                            timerProgressBar: false,
                            confirmButtonColor: "#0FCB4F",
                            cancelButtonColor: "#EC2641",
                        });
					}
                }
            });
        }
    },
    computed: {
        
    },
    props: {
        
    },
    mixins: [juniperUserMixin]
};
</script>
<style scoped>
    .juniper-table tbody tr.selected {
        color: #000;
        font-weight: 700;
        background-color: rgba(0,0,0,.2);
    }
</style>
